export const TOP_PADDING = 10;
export const LEFT_PADDING = 10;
export const FONT_RECT = [16, 16];
export const MONITOR_WIDTH = FONT_RECT[0] * 30 + LEFT_PADDING + 8;
export const MONITOR_HEIGHT = FONT_RECT[1] * 24 + TOP_PADDING * 2;
